import { useCallback, useState } from "react";

const useInput = (initialState = "") => {
  const [state, setState] = useState(initialState);
  const setInputState = useCallback(event => setState(event.target.value), []);
  return [ state, setInputState ];
};

export default useInput;